import React from 'react';
import { AdminSection } from '../types/admin';
import {
  AppTab,
  NavDefinition,
  AdminGroupDefinition,
  PRIMARY_NAV_MODEL,
  ADMIN_GROUPS_MODEL,
  canSeeNav as canSeeNavModel,
  canSeeAdminConfig,
  canRaiseComplaint,
} from './navigationModel';
import {
  LayoutDashboard, BarChart, ListFilter, Wrench, UserCheck, ShieldCheck,
  Building2, HardHat, Database, Settings, Plus, Layers, Tag, ListTree,
  ShieldAlert, Activity, SlidersHorizontal, Bell, Settings2, Hash, Key,
  History, ShieldCheck as ShieldCheckIcon, LogIn,
} from 'lucide-react';

export * from './navigationModel';

export interface NavItem extends NavDefinition {
  icon: React.ReactNode;
}

export interface AdminNavItem {
  id: AdminSection;
  label: string;
  icon: React.ReactNode;
}

export interface AdminGroup extends AdminGroupDefinition {
  items: AdminNavItem[];
}

const PRIMARY_ICONS: Record<AppTab, React.ReactNode> = {
  dashboard: <LayoutDashboard className="w-4 h-4" />,
  reports: <BarChart className="w-4 h-4" />,
  complaints: <ListFilter className="w-4 h-4" />,
  workorders: <Wrench className="w-4 h-4" />,
  'my-workorders': <Wrench className="w-4 h-4" />,
  officer: <UserCheck className="w-4 h-4" />,
  supervisor: <ShieldCheck className="w-4 h-4" />,
  vendors: <Building2 className="w-4 h-4" />,
  technician: <HardHat className="w-4 h-4" />,
  masters: <Database className="w-4 h-4" />,
  'admin-config': <Settings className="w-4 h-4" />,
  profile: <UserCheck className="w-4 h-4" />,
};

const ADMIN_ICONS: Record<AdminSection, React.ReactNode> = {
  organization: <Building2 className="w-4 h-4" />,
  departments: <Layers className="w-4 h-4" />,
  categories: <Tag className="w-4 h-4" />,
  subcategories: <ListTree className="w-4 h-4" />,
  priorities: <ShieldAlert className="w-4 h-4" />,
  statuses: <Activity className="w-4 h-4" />,
  'sla-rules': <SlidersHorizontal className="w-4 h-4" />,
  'notification-rules': <Bell className="w-4 h-4" />,
  'custom-fields': <Settings2 className="w-4 h-4" />,
  'number-patterns': <Hash className="w-4 h-4" />,
  'users': <UserCheck className="w-4 h-4" />,
  'roles-permissions': <Key className="w-4 h-4" />,
  'general-settings': <Settings2 className="w-4 h-4" />,
  'audit-logs': <History className="w-4 h-4" />,
  'security-settings': <ShieldCheckIcon className="w-4 h-4" />,
  'login-history': <LogIn className="w-4 h-4" />,
};

export const PRIMARY_NAV: NavItem[] = PRIMARY_NAV_MODEL.map((item) => ({
  ...item,
  icon: PRIMARY_ICONS[item.id],
}));

export const ADMIN_GROUPS: AdminGroup[] = ADMIN_GROUPS_MODEL.map((group) => ({
  ...group,
  items: group.items.map((item) => ({ ...item, icon: ADMIN_ICONS[item.id] })),
}));

export const canSeeNav = (item: NavDefinition, role: Parameters<typeof canSeeNavModel>[1]) =>
  canSeeNavModel(item, role);

export { canSeeAdminConfig, canRaiseComplaint };

export const RAISE_COMPLAINT_ICON = <Plus className="w-4 h-4" />;
